import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'

interface LedgerListQuery {
  page?: number
  limit?: number
  direction?: string
  category?: string
  projectId?: string
  from?: string
  to?: string
}

export function useLedger(query: LedgerListQuery = {}) {
  return useQuery({
    queryKey: ['ledger', query],
    queryFn: () => api.ledger.list(query),
  })
}

interface LedgerSummaryQuery {
  period?: string
  projectId?: string
  from?: string
  to?: string
}

export function useLedgerSummary(query: LedgerSummaryQuery = {}) {
  return useQuery({
    queryKey: ['ledger-summary', query],
    queryFn: () => api.ledger.summary(query),
    select: (res) => res.data,
  })
}
